import type { ReactNode } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { AiTwotoneAlert } from 'react-icons/ai';
import { getColor } from '@/helpers/utils';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

interface CheckListCardSkeletonProps {
  title: ReactNode;
  color: string;
  tooltip?: ReactNode;
  items: number[];
}

// اسکلتون برای زمانی که کارت چک لیست لود نشده
const CheckListCardSkeleton = ({
  title,
  color,
  tooltip,
  items
}: CheckListCardSkeletonProps): React.JSX.Element => (
  <Card className="h-md-100" aria-busy="true" aria-label="درحال بارگذاری">
    <FalconCardHeader
      light
      title={
        <div className="fw-bold py-0 my-0 d-flex align-items-center justify-content-between gap-1">
          <span>
            <AiTwotoneAlert
              size={25}
              className="me-2"
              color={getColor(color)}
            />
            {title}
            <span className="fs-0">
              <HelpTooltip html={tooltip} />
            </span>
          </span>
          <TextLoading width={44} height={24} isWidthPx />
        </div>
      }
    />
    <Card.Body>
      <Row className="justify-content-between g-0">
        <Col xs={12}>
          <div className="d-flex flex-column gap-2 pt-2">
            {items.map((item, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-between gap-2"
              >
                <div className="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden">
                  <TextLoading width={14} height={14} isWidthPx />
                  <TextLoading width={item} height={12} />
                  <TextLoading width={12} height={12} isWidthPx />
                </div>
                <TextLoading width={30} height={12} isWidthPx />
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default CheckListCardSkeleton;
